export const config = {
  api_key: "186779eec733886b0b166329c37022ab",
  api_base_url: "https://api.themoviedb.org/3/",
  image_base_url: "https://image.tmdb.org/t/p/w1280",
};
